<template>
  <div id="grupoProdutosId">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <!-- <br><br> -->
      <div class="d-flex justify-start align-center px-1">
        <v-btn
          id="btnPrint"
          class="cols-12 sm-3 md-3 lg-1"
          small
          dark
          :disabled="enableBtn"
          :color="corPrimaria"
          :loading="imprimindo"
          @click="exportPdf()"
        >
          <v-icon>
            mdi-printer
          </v-icon>
          Exporta Pdf
          <template v-slot:loader>
            <span>Gerando...</span>
          </template>
        </v-btn>
      </div>
      <div
        id="idTable"
        style="overflow-x: auto;"
      >
        <table
          style="width: 100%; color: black; border-collapse: collapse;"
          class="elevation-1"
        >
          <thead>
            <tr>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              />
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('area')"
              >
                Area
                <v-icon small>
                  {{ ordenarDados === 'area' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('quantidadeOrdenacao')"
              >
                Quantidade
                <v-icon small>
                  {{ ordenarDados === 'quantidadeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('faturamentoOrdenacao')"
              >
                Faturamento
                <v-icon small>
                  {{ ordenarDados === 'faturamentoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('volumeOrdenacao')"
              >
                Volume (L)
                <v-icon small>
                  {{ ordenarDados === 'volumeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('cmvOrdenacao')"
              >
                CMV
                <v-icon small>
                  {{ ordenarDados === 'cmvOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemBrutaOrdenacao')"
              >
                Margem Bruta R$
                <v-icon small>
                  {{ ordenarDados === 'margemBrutaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemPorcentagemBrutaOrdenacao')"
              >
                Margem Bruta %
                <v-icon small>
                  {{ ordenarDados === 'margemPorcentagemBrutaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemContribuicaoOrdenacao')"
              >
                Margem Contribuição %
                <v-icon small>
                  {{ ordenarDados === 'margemContribuicaoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in faturamento"
            :key="item.id"
          >
            <!-- Linha principal -->
            <tr>
              <td style="text-align: center;">
                <button @click="toggleExpand(index)">
                  {{ expanded.includes(index) ? '▲' : '▼' }}
                </button>
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.area }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.quantidade }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.faturamento }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.volume }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.cmv }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemBruta }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemPorcentagemBruta }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemContribuicao }}
              </td>
            </tr>
            <!-- Linha expandida -->
            <tr
              v-if="expanded.includes(index)"
              :key="'expanded-' + item.id"
            >
              <td colspan="10">
                <table
                  id="tableExpandida"
                  style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center; width: 23.8%;"
                        @click="mudarOrdenacaoAreas('cidade', index)"
                      >
                        Cidade
                        <v-icon small>
                          {{ ordenarDadosAreas === 'cidade' ? (ordenacaoDadosAreasDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoAreas('quantidadeOrdenacao', index)"
                      >
                        Quantidade
                        <v-icon small>
                          {{ ordenarDadosAreas === 'quantidadeOrdenacao' ? (ordenacaoDadosAreasDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoAreas('faturamentoOrdenacao', index)"
                      >
                        Faturamento
                        <v-icon small>
                          {{ ordenarDadosAreas === 'faturamentoOrdenacao' ? (ordenacaoDadosAreasDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoAreas('volumeOrdenacao', index)"
                      >
                        Volume (L)
                        <v-icon small>
                          {{ ordenarDadosAreas === 'volumeOrdenacao' ? (ordenacaoDadosAreasDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoAreas('cmvOrdenacao', index)"
                      >
                        CMV
                        <v-icon small>
                          {{ ordenarDadosAreas === 'cmvOrdenacao' ? (ordenacaoDadosAreasDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoAreas('margemBrutaOrdenacao', index)"
                      >
                        Margem Bruta R$
                        <v-icon small>
                          {{ ordenarDadosAreas === 'margemBrutaOrdenacao' ? (ordenacaoDadosAreasDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoAreas('margemPorcentagemBrutaOrdenacao', index)"
                      >
                        Margem Bruta %
                        <v-icon small>
                          {{ ordenarDadosAreas === 'margemPorcentagemBrutaOrdenacao' ? (ordenacaoDadosAreasDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoAreas('margemContribuicaoOrdenacao', index)"
                      >
                        Margem Contribuição %
                        <v-icon small>
                          {{ ordenarDadosAreas === 'margemContribuicaoOrdenacao' ? (ordenacaoDadosAreasDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(sub, idx) in item.dadosCidades"
                      :key="idx"
                    >
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ sub.cidade }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.quantidade }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.faturamento }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.volume }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.cmv }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemBruta }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemPorcentagemBruta }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemContribuicao }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import AnaliseMargem from '../../../../../services/analisemargem2'
  import eventEmit from '../../core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      area: [],
      rede: [],
      supervisor: [],
      classificacao: [],
      linhasProducao: [],
      produtos: [],
      cidades: [],
      headers: [
        { text: 'Area', value: 'area', width: '20%', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Volume (l)', value: 'volume', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'CMV', value: 'cmv', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta R$', value: 'margemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta %', value: 'margemPorcentatemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Contribuição %', value: 'margemContribuicao', align: 'right', width: '10%', class: 'black--text title' },
      ],
      headersVendedores: [
        { text: 'Cidade', value: 'vendedor', width: '20%', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Volume (l)', value: 'volume', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'CMV', value: 'cmv', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta R$', value: 'margemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta %', value: 'margemPorcentatemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Contribuição %', value: 'margemContribuicao', align: 'right', width: '10%', class: 'black--text title' },
      ],
      expanded: [],
      faturamento: [],
      faturamentoVendedores: [],
      enableBtn: true,
      imprimindo: false,
      ordenarDados: '',
      ordenacaoDadosDecrescente: false,
      ordenarDadosAreas: '',
      ordenacaoDadosAreasDecrescente: false,
    }),

    created () {
      eventEmit.$on('show-dados-tabela', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('show-dados-tabela', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, area, redes, supervisor, classificacao, linhasProducao, produtos, cidades) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.area = area
        this.rede = redes
        this.supervisor = supervisor
        this.classificacao = classificacao
        this.linhasProducao = linhasProducao
        this.produtos = produtos
        this.cidades = cidades

        this.showMargemCliente()
      },

      async showMargemCliente () {
        this.loading = true

        this.faturamento = []

        this.enableBtn = true

        this.ordenarDados = ''
        this.ordenacaoDadosDecrescente = false
        this.ordenarDadosAreas = ''
        this.ordenacaoDadosAreasDecrescente = false

        await AnaliseMargem.showAnaliseMargemArea(this.primeiroDia, this.ultimoDia, this.empresa, this.area, this.rede, this.supervisor, this.classificacao, this.linhasProducao, this.produtos, this.cidades, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.faturamento = resposta.data.dadosExibicao.map((item) => {
              var listaFaturamento = ({
                area: item.area,
                quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                cmv: parseFloat(item.cmv).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemBruta: parseFloat(item.margemBruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemPorcentagemBruta: parseFloat(item.margemPorcentatemBruta).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                margemContribuicao: parseFloat(item.margemContribuicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                quantidadeOrdenacao: parseFloat(item.quantidade),
                faturamentoOrdenacao: parseFloat(item.faturamento),
                volumeOrdenacao: parseFloat(item.volume),
                cmvOrdenacao: parseFloat(item.cmv),
                margemBrutaOrdenacao: parseFloat(item.margemBruta),
                margemPorcentagemBrutaOrdenacao: parseFloat(item.margemPorcentatemBruta),
                margemContribuicaoOrdenacao: parseFloat(item.margemContribuicao),
                dadosCidades: this.dadosCidade(item.dadosCidades),
              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      dadosCidade (value) {
        const dados = value.map((item) => {
          var listaDados = ({
            cidade: item.cidade,
            quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            cmv: parseFloat(item.cmv).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemBruta: parseFloat(item.margemBruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemPorcentagemBruta: parseFloat(item.margemPorcentatemBruta).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            margemContribuicao: parseFloat(item.margemContribuicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            quantidadeOrdenacao: parseFloat(item.quantidade),
            faturamentoOrdenacao: parseFloat(item.faturamento),
            volumeOrdenacao: parseFloat(item.volume),
            cmvOrdenacao: parseFloat(item.cmv),
            margemBrutaOrdenacao: parseFloat(item.margemBruta),
            margemPorcentagemBrutaOrdenacao: parseFloat(item.margemPorcentatemBruta),
            margemContribuicaoOrdenacao: parseFloat(item.margemContribuicao),
          })

          return listaDados
        })

        return dados
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      async exportPdf () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.area.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.rede.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionada(s):', this.supervisor.map(r => r.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Produtos(s) Selecionado(s):', this.produtos.map(p => p.produto))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Classificação(ões) Selecionada(s):', this.classificacao.map(c => c.classificacao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Linhas Produto(s) Selecionada(s):', this.linhasProducao.map(l => l.linhaProducao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(c => c.cidade))

          if (posYFiltros > 100) {
            pdf.addPage()

            posYFiltros = 10
          }

          const tituloGrafico = 'Relatório Margem por Rede'
          pdf.text(tituloGrafico, 15, posYFiltros)
          posYFiltros += 10 + pdf.getTextDimensions(tituloGrafico).h

          let previousTableY = posYFiltros

          this.faturamento.forEach((row, index) => {
            const dadosTablePrincipal = [
              [row.area, row.quantidade, row.faturamento, row.volume, row.cmv, row.margemBruta, row.margemPorcentatemBruta, row.margemContribuicao],
            ]

            const tablePrincipal = pdf.autoTable({
              head: [this.headers.map(header => ({ content: header.text, styles: { fontSize: 8, textColor: [0, 0, 0] } }))],
              body: dadosTablePrincipal.map(r => r.map((cell, index) => {
                const isTextColumn = index === 0
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isTextColumn ? 'left' : 'right',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 8 },
            })

            previousTableY = tablePrincipal.lastAutoTable.finalY

            const dadosDetalheCidades = row.dadosCidades.map(item => [item.cidade, item.quantidade, item.faturamento, item.volume, item.cmv, item.margemBruta, item.margemPorcentatemBruta, item.margemContribuicao])

            const tableDetalhes = pdf.autoTable({
              head: [this.headersVendedores.map(header => ({ content: header.text, styles: { fontSize: 8, textColor: [0, 0, 0] } }))],
              body: dadosDetalheCidades.map(r => r.map((c, i) => {
                const isTextColumnVendedor = i === 0
                return {
                  content: c,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isTextColumnVendedor ? 'left' : 'right',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 8 },
            })

            previousTableY = tableDetalhes.lastAutoTable.finalY + 10
          })

          pdf.save('relatorio_margem_rede.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      mudarOrdenacao (campo) {
        if (this.ordenarDados === campo) {
          this.ordenacaoDadosDecrescente = !this.ordenacaoDadosDecrescente
        } else {
          this.ordenarDados = campo
          this.ordenacaoDadosDecrescente = false
        }

        this.buscarDadosOrdenados()
      },

      buscarDadosOrdenados () {
        const novaOrdenacao = [...this.faturamento]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDados] < b[this.ordenarDados]) result = -1
          if (a[this.ordenarDados] > b[this.ordenarDados]) result = 1

          if (this.ordenacaoDadosDecrescente) result *= -1

          return result
        })

        this.faturamento = novaOrdenacao
      },

      mudarOrdenacaoAreas (campo, index) {
        if (campo === this.ordenarDadosAreas) {
          this.ordenacaoDadosAreasDecrescente = !this.ordenacaoDadosAreasDecrescente
        } else {
          this.ordenarDadosAreas = campo
          this.ordenacaoDadosAreasDecrescente = false
        }

        this.ordenarDadosArea(index)
      },

      ordenarDadosArea (index) {
        const novaOrdenacao = [...this.faturamento[index].dadosCidades]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDadosAreas] < b[this.ordenarDadosAreas]) result = -1
          if (a[this.ordenarDadosAreas] > b[this.ordenarDadosAreas]) result = 1

          if (this.ordenacaoDadosAreasDecrescente) result *= -1

          return result
        })

        this.faturamento[index].dadosCidades = novaOrdenacao
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #btnPrint {
    margin: 0 0 1rem -0.3rem
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #grupoProdutos {
      font-size: 10px;
      max-width: 100%
    }

    #idTable {
      max-height: 500px;
      /* max-width: 370px !important; */
      max-width: 90vw;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }

    #tableExpandida {
      margin: 0 0rem 0 0rem;
      /* width: 95%; */
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #grupoProdutosId {
      width: 100%;
    }

    #grupoProdutos {
      font-size: 10px;
      max-width: 100%;
    }
  }
</style>

<style lang="sass">
  #grupoProdutos
    data-table-scroll-bar-width: 17px

  #tableVendedorRede
    margin: 0 0 0 2.5rem

</style>
